<script >
export default {
  props: ['value','listType', 'showFileList', 'accept', 'limit','list', 'drag'],
  data() {
    return {
      item: {
        type: 'image',
        fileList: []
      }
    }
  },
  watch: {
    value: {
      handler: function(v) {
        if (v) {
          if(this.item.fileList.length === 0) {
            this.item.fileList = [{url: v, response: {url: v}}]
          }
        }
        else this.item.fileList = []
      },
      immediate: true
    }
  },
  methods: {
    onSuccess(item, { response, file, fileList }) {
      // console.log(response)
      if (response) response.url = (process.env.NODE_ENV === 'development' ? '' : '') + response.url
      // fileList[fileList.length-1].name = response.name
      // item.fileList = fileList.map(x=>({name: x.name, url: x.url}))
      item.fileList = fileList
      // console.log(item.fileList)
      this.$emit('input', response.url)
      this.$emit('update:list', item.fileList)
    },
    onRemove(item, { file, fileList }) {
      // item.fileList = fileList.map(x=>({name: x.name, url: x.url}))
      item.fileList = fileList
      this.$emit('input', '')
      this.$emit('update:list', item.fileList)
    },
    onPreview(item, e) {
      if (item.type === 'file') {
        window.open(e.file.url)
      } else if (item.type === 'image' || item.type === 'images') {
        window.open(e.file.url) // 暂时直接新窗口查看
      }
    }
  }
}
</script>

<template>
  <el-upload
    action="/user/upfiles/uploadFile"
    :headers="{'X-Requested-With': 'XMLHttpRequest'}"
    :limit="limit || 1"
    :accept="accept || '.*'"
    :list-type="listType || 'text'"
    :show-file-list="showFileList || false"
    :file-list="item.fileList"
    :with-credentials="true"
    :drag="drag || false"
    :class="{'hide': item.fileList.length>=1}"
    :on-success="(response, file, fileList)	=>onSuccess(item,{response, file, fileList})"
    :on-remove="(file, fileList)	=>onRemove(item,{file, fileList})"
    :on-preview="(file) => onPreview(item, {file})"
  >
    <slot >
      <i slot="default" class="el-icon-plus" />
    </slot>
  </el-upload>
</template>

<style scoped>
/deep/ .hide .el-upload--picture-card {
  display: none;
}
/*el-element 上传文件会有跳动的效果。加上上述代码可以去掉该动效*/
::v-deep  .el-upload-list__item{
  transition:none !important;
  -webkit-transition:nonne !important;
}
::v-deep   .el-upload-list__item-name{
  transition:none !important;
  -webkit-transition:nonne !important;
}

::v-deep .el-upload input{
    display: none;
}
</style>
